import axios from "axios";
import Router from "@/router";
import store from "@/store";

// 新加密解密方法
import Qs from "qs";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

// 防止重复请求
const removePending = config => {
  for (const k in store.getters.axiosPing) {
    if (store.getters.axiosPing[k].u === config.url + "&" + config.method) {
      // 当前请求在数组中存在时执行函数体
      store.getters.axiosPing[k].f(); // 执行取消操作
      store.commit("REMOVE_AXIOS_PING", k); // 把这条记录从数组中移除
    }
  }
};

// 指定请求超时的毫秒数;
// axios.defaults.timeout = 5000
// 指定 post 请求头；
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'

axios.interceptors.request.use(
  config => {
    if (!config.pending) {
      // pending 手动传进来的，如果传进来了就不记录。
      removePending(config);
      config.cancelToken = new axios.CancelToken(c => {
        // 取消请求的配置
        // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
        store.commit("PUSH_AXIOS_PING", {
          u: config.url + "&" + config.method,
          f: c
        });
      });
    }

    if (config.data) {
      config.data.entrance = config.data.entrance ? config.data.entrance : "3";
      config.data.imei = 0;
      config.data.model = 0;
      config.data.version = "2.2";
      config.data.language = store.getters.language == "en" ? "en-us" : "zh-cn";
      config.data.token = store.getters.token;
      config.data.encryption = 1;
      console.log("config===", config.data);
      if (config.data.encryption == 1) {
        delete config.data.encryption;
      } else {
        // 新加密
        config.key = randomStr("key");
        config.iv = randomStr("iv");
        let newConfig = {};
        newConfig.data = Encrypt(
          JSON.stringify(config.data),
          config.key,
          config.iv
        );
        newConfig.key = RsaEncrypt(config.key);
        newConfig.iv = RsaEncrypt(config.iv);
        // let configData = {}
        // configData.data = JSON.stringify(newConfig)
        config.data = Qs.stringify(newConfig);
      }
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    removePending(response.config);
    if (response.data.type == 1) {
      // 新解密
      var key = response.config.key;
      var iv = response.config.iv;
      response.data.data = JSON.parse(Decrypt(response.data.data, key, iv));
    }
    return response.data;
  },
  error => {
    // if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    //   console.log('根据你设置的timeout/真的请求超时 判断请求现在超时了，你可以在这里加入超时的处理方案')
    //   // `这里我 的方案是，超时后再次请求，所以新建了一个promise`
    //   var newHttp = new Promise(function (resolve) {
    //     resolve()
    //   })
    //   // `newHttp实例执行完成后会再次执行`
    //   // 返回一个promise实例，同时重新发起请求，config请求配置，包扩请求头和请求参数
    //   return newHttp.then(function () {
    //     return axios(error.config)
    //   })
    // }
    var data = {
      code: -1,
      data: {},
      msg: error.message
    };
    return Promise.reject(data);
  }
);

let loadingNum = 0;

function addLoading(loading) {
  if (loading) {
    loadingNum++;
    store.dispatch("LOADING_SHOW", true);
  }
}
function removeLoading(loading) {
  if (loading) {
    if (loadingNum > 0) {
      loadingNum--;
    }
    if (loadingNum == 0) {
      store.dispatch("LOADING_SHOW", false);
    }
  }
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, loading = true, pending = false) {
  addLoading(loading);
  return new Promise((resolve, reject) => {
    axios.post(url, data, pending).then(
      res => {
        removeLoading(loading);
        if (res.code == 40005) {
          // localStorage.clear();//清空所有
          localStorage.setItem("token", "");
          store.dispatch("GET_USER_INFO", { obj: "delete" });
          store.dispatch("SET_TOKEN", "");

          if (Router.history.current.meta.power) {
            Router.push({ path: "/login" });
          }
          return false;
        }
        if (res.code == 10000) {
          // 维护状态！
          Router.push({ path: "/maintain" });
        }
        if (res.code == 0) {
          resolve(res.data);
        } else {
          debugger;
          reject(res);
        }
      },
      err => {
        removeLoading(loading);
        reject(err);
      }
    );
  });
}

// 新加密解密
function Encrypt(word, keyStr, ivStr) {
  // 加密
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let iv = CryptoJS.enc.Utf8.parse(ivStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

function Decrypt(word, keyStr, ivStr) {
  // 解密
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let iv = CryptoJS.enc.Utf8.parse(ivStr);
  let base64 = CryptoJS.enc.Base64.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(base64);
  var decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function RsaEncrypt(data) {
  // Rsa加密
  // console.log('Rsa加密前数据:', data);
  var PUBLIC_KEY =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+r5K03C0cQ9FGXIxnRlnJs3F24Z0WvTil1lPJoYLzR9TH88wek4XKYpAQuQMPHpbQb7zZM2mGNUUG36onO8AaFdKPXE5um2da2EmJpX6llY47B5Na5318jPyFDf+aFkrYTn094EtUB7U6DJgfUJKue3wpvyqhHsANcxXOst/IGwIDAQAB";
  var encrypt = new JSEncrypt();
  encrypt.setPublicKey(
    "-----BEGIN PUBLIC KEY-----" + PUBLIC_KEY + "-----END PUBLIC KEY-----"
  );
  var encrypted = encrypt.encrypt(data);
  // console.log('Rsa加密后数据:', encrypted);
  return encrypted;
}

function randomStr(flag, len) {
  // 随机字符串
  len = len || 16;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var str = "";
  for (var i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  // console.log('随机字符串:' + flag, str);
  return str;
}
